/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type prospects_CompleteProspectTourRequest = {
    close_probability: number;
    /**
     * ConductedByEmployeeID defaults to the tour's assigned employee when omitted.
     */
    conducted_by_employee_id?: string;
    impression?: string;
    /**
     * NextFollowupDate is date-only and optional: a supplied value SETS the
     * prospect's follow-up date through the communication service's existing write
     * path, an omitted value leaves it unchanged.
     */
    next_followup_date?: string;
    notes?: string;
    outcome: prospects_CompleteProspectTourRequest.outcome;
    prospect_version: number;
};
export namespace prospects_CompleteProspectTourRequest {
    export enum outcome {
        INTERESTED = 'interested',
        UNSURE = 'unsure',
        CALLBACK_AGREED = 'callback_agreed',
        TOUR_BOOKED = 'tour_booked',
        NO_INTEREST = 'no_interest',
        NO_ANSWER = 'no_answer',
        OTHER = 'other',
    }
}

